import { pow } from 'mathjs';
import { TranslateHelper } from '../../helpers/injector.helper';
import { ValueAndType } from '../basic/formulaEditor.model';
import { OperationType } from '../enums/operationtype.enum';
import { ValueType } from '../enums/valuetype.enum';
import { FormulaNodeCalculator } from './formula.node.calculator';
import { AFormula, FormulaGroups } from './iformula';

export class Pow extends AFormula {
    static StaticID = '44f02179-0fe6-461d-8cf5-6902f325a60e';

    ID(): string {
        return Pow.StaticID;
    }
    Name(): string {
        return 'Pow';
    }
    Caption(): string {
        return '@@Potenz';
    }
    Description(): string {
        return '@@Potenz Berechnung';
    }
    MinVariableCount(): number {
        return 2;
    }
    MaxVariableCount(): number {
        return 2;
    }
    Group(): string {
        return FormulaGroups.Functions;
    }
    OrderID(): number {
        return 1010;
    }
    OperationType(): OperationType {
        return OperationType.Function;
    }
    OperationValue(): string {
        return this.Name() + '(' + TranslateHelper.TranslatorInstance.instant('@@Wert') + '; '
            + TranslateHelper.TranslatorInstance.instant('@@Potenz') + ')';
    }
    Calc(fnc: FormulaNodeCalculator, maxType: ValueType, args?: ValueAndType[]): ValueAndType {
        const retVal = new ValueAndType();
        if (args && args.length > 1) {
            const first = args[0];
            const second = args[1];
            if ((first.Type === ValueType.Double && second.Type === ValueType.Double) ||
                (first.Type === ValueType.Long && second.Type === ValueType.Long)) {
                retVal.Type = ValueType.Double;
                retVal.Value = pow(first.Value, second.Value);
            }
        }
        return retVal;
    }
}
